import { render, staticRenderFns } from "./external-accounts.vue?vue&type=template&id=4e8fc585"
import script from "./external-accounts.vue?vue&type=script&lang=js"
export * from "./external-accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports